"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearIcon = void 0;
var React = require("react");
var ClearIcon = /** @class */ (function (_super) {
    __extends(ClearIcon, _super);
    function ClearIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClearIcon.prototype.render = function () {
        return (React.createElement("svg", { width: "8px", height: "8px", viewBox: "0 0 8 8", version: "1.1" },
            React.createElement("title", null, "X"),
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
                React.createElement("g", { transform: "translate(-8.000000, -8.000000)", fill: "currentColor" },
                    React.createElement("g", { transform: "translate(8.000000, 8.000000)" },
                        React.createElement("polygon", { points: "7.38461538 9.32587341e-15 8 0.615384615 4.615 4 8 7.38461538 7.38461538 8 4 4.615 0.615384615 8 -4.61852778e-14 7.38461538 3.384 4 -4.57411886e-14 0.615384615 0.615384615 9.2148511e-15 4 3.385" }))))));
    };
    return ClearIcon;
}(React.Component));
exports.ClearIcon = ClearIcon;
//# sourceMappingURL=ClearIcon.js.map